import styled from "styled-components";
import BaseInput from "./baseInput";

const CheckboxInput = styled(BaseInput).attrs({
  type: "checkbox",
})``;

export default CheckboxInput;
